<template>
    <div v-bind:class="'message ' + messageStatus">
        {{ messageContent }}
    </div>
</template>

<script>
export default {
  name: 'Message',
  props: ['messageContent', 'messageStatus'],
  data () {
    return {
      
    }
  }
}
</script>

<style scoped lang="scss">
    .message {
        width: 100%;
        padding: 16px;
        font-size: 16px;
        border-radius: 4px;
        color: #2C3235;
        letter-spacing: 0.2px;
        line-height: 16px;
        margin-bottom: 32px;
        &.error {
            background: rgba(196,75,73,0.04);
            border: 1px solid rgba(196,75,73,0.16);
        }
        &.success {
            background: rgba(68,184,90,0.04);
            border: 1px solid rgba(68,184,90,0.16);
        }
    }
</style>



// WEBPACK FOOTER //
// Message.vue?51914314